module.exports = __webpack_public_path__ + "static/media/splash-phone.0b90dbf4.png";